import { useEffect, useState } from 'react';
import { Card, Row, Col, Table, Badge, Alert, Spinner } from 'react-bootstrap';
import { FaDollarSign, FaHourglassHalf } from 'react-icons/fa';
import { api } from '../api/client';

export default function TeacherEarnings() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    api.get('/teacher/earnings').then(setData).catch((e) => setErr(e.message));
  }, []);

  if (err) return <Alert variant="danger">{err}</Alert>;
  if (!data) return <div className="text-center py-5"><Spinner /></div>;

  return (
    <>
      <h3 className="mb-4">My Earnings</h3>
      <Row className="mb-4">
        <Col md={4}>
          <Card className="shadow-sm"><Card.Body>
            <FaDollarSign size={28} className="text-success mb-2" />
            <Card.Title>Total paid out</Card.Title>
            <h3>₹{Number(data.totals.total_paid).toFixed(2)}</h3>
          </Card.Body></Card>
        </Col>
        <Col md={4}>
          <Card className="shadow-sm"><Card.Body>
            <FaHourglassHalf size={28} className="text-warning mb-2" />
            <Card.Title>Pending settlement</Card.Title>
            <h3>₹{Number(data.totals.total_pending).toFixed(2)}</h3>
          </Card.Body></Card>
        </Col>
      </Row>

      <h5>Settlements</h5>
      <Table bordered hover responsive className="bg-white">
        <thead className="table-dark"><tr><th>Month</th><th>Student</th><th>Gross</th><th>Commission</th><th>Net</th><th>Status</th><th>Paid at</th><th>Notes</th></tr></thead>
        <tbody>
          {data.settlements.length === 0 && <tr><td colSpan={8} className="text-center text-muted">No settlements yet</td></tr>}
          {data.settlements.map((s) => (
            <tr key={s.id}>
              <td>{s.period_month}</td>
              <td>{s.student_name}</td>
              <td>₹{Number(s.gross).toFixed(0)}</td>
              <td>{Number(s.commission_pct).toFixed(1)}% (₹{Number(s.commission_amount).toFixed(0)})</td>
              <td><strong>₹{Number(s.net_payable).toFixed(0)}</strong></td>
              <td><Badge bg={s.status === 'paid' ? 'success' : 'warning'}>{s.status}</Badge></td>
              <td>{s.paid_at || '-'}</td>
              <td>{s.notes || '-'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
}
